const config = {
        contractAddress : "KT1BqdAjpGirq6A9cPF7YVjJcNeysYRZUSoa", 
        tokenAddress: "KT1EBjCkaAXhB8xxX5X4Ant6MsgNFWnk4Jj6"
}

export default config;